/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPasswordDto
 */
export interface SetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordDto
     */
    confirmPassword?: string | null;
}

/**
 * Check if a given object implements the SetPasswordDto interface.
 */
export function instanceOfSetPasswordDto(value: object): value is SetPasswordDto {
    return true;
}

export function SetPasswordDtoFromJSON(json: any): SetPasswordDto {
    return SetPasswordDtoFromJSONTyped(json, false);
}

export function SetPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasswordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
        'password': json['password'] == null ? undefined : json['password'],
        'confirmPassword': json['confirmPassword'] == null ? undefined : json['confirmPassword'],
    };
}

export function SetPasswordDtoToJSON(json: any): SetPasswordDto {
    return SetPasswordDtoToJSONTyped(json, false);
}

export function SetPasswordDtoToJSONTyped(value?: SetPasswordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'password': value['password'],
        'confirmPassword': value['confirmPassword'],
    };
}

